import React from 'react';
const Deaths = () => {
    return (
        <div>
            <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 32" class="h-12 py-1 m-auto"><path fill="#c53030" d="M46.54,24.69H2.91V9.45A1.46,1.46,0,0,0,0,9.45v29.1a1.46,1.46,0,0,0,2.91,0V33.32H45.09v5.23a1.46,1.46,0,0,0,2.91,0V26.15A1.46,1.46,0,0,0,46.54,24.69Z" transform="translate(0 -8)"></path> <path fill="#c53030" d="M6.44,23.68h8.8a2.43,2.43,0,0,0,2.43-2.43v-1a2.43,2.43,0,0,0-2.43-2.42H6.44A2.43,2.43,0,0,0,4,20.22v1A2.43,2.43,0,0,0,6.44,23.68Z" transform="translate(0 -8)"></path></svg>
        </div>
    );
}

export default Deaths;